module.exports = __webpack_public_path__ + "static/media/classroom.af32bcd6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/backgrounds/classroom.jpg
// module id = 232
// module chunks = 0